<template>
  <b-modal
    :id="modalId"
    centered
    hide-footer
    hide-header
    dialog-class="modal-preview-image-dialog"
    content-class="modal-preview-image-content"
    body-class="modal-preview-image-body"
    @hidden="handleHidden"
  >
    <div class="d-flex justify-content-end mb-1">
      <b-button
        variant="link"
        class="p-0 text-dark d-flex align-items-center justify-content-center modal-preview-close-btn"
        @click="$bvModal.hide(modalId)"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="#626262"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </b-button>
    </div>
    <div class="modal-preview-image-container">
      <video
        v-if="resolvedVideoUrl"
        ref="previewVideo"
        :src="resolvedVideoUrl"
        class="modal-preview-img"
        controls
        autoplay
      />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalPreviewVideo',
  props: {
    modalId: {
      type: String,
      default: 'modal-preview-video',
    },
    videoUrl: {
      type: [String, Object, File],
      default: '',
    },
  },
  data() {
    return {
      createdBlobUrl: '',
    }
  },
  computed: {
    resolvedVideoUrl() {
      if (!this.videoUrl) return ''
      if (typeof this.videoUrl === 'string') return this.videoUrl
      if (
        typeof window !== 'undefined' &&
        (this.videoUrl instanceof File || this.videoUrl instanceof Blob)
      ) {
        if (this.createdBlobUrl) {
          URL.revokeObjectURL(this.createdBlobUrl)
        }
        this.createdBlobUrl = URL.createObjectURL(this.videoUrl)
        return this.createdBlobUrl
      }
      return ''
    },
  },
  beforeDestroy() {
    if (this.createdBlobUrl) {
      URL.revokeObjectURL(this.createdBlobUrl)
      this.createdBlobUrl = ''
    }
  },
  methods: {
    handleHidden() {
      if (this.$refs.previewVideo) {
        this.$refs.previewVideo.pause()
      }
      if (this.createdBlobUrl) {
        URL.revokeObjectURL(this.createdBlobUrl)
        this.createdBlobUrl = ''
      }
      this.$emit('hidden')
    },
  },
}
</script>

<style>
.modal-preview-image-dialog {
  max-width: calc(100vw - 32px) !important;
  width: -webkit-fit-content !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

@media (min-width: 576px) {
  .modal-preview-image-dialog {
    max-width: 90vw !important;
    margin: 1.75rem auto !important;
  }
}

.modal-preview-image-dialog .modal-content {
  width: -webkit-fit-content !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
  max-width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  border-radius: 12px !important;
  border: none !important;
  background-color: #ffffff !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
  overflow: hidden;
}

.modal-preview-image-dialog .modal-body {
  padding: 8px !important;
  width: -webkit-fit-content !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
  max-width: 100% !important;
  min-width: 120px;
}

.modal-preview-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.modal-preview-img {
  display: block;
  width: auto !important;
  height: auto !important;
  max-width: calc(90vw - 32px) !important;
  max-height: 80vh !important;
  object-fit: contain;
  border-radius: 6px;
}

@media (min-width: 1000px) {
  .modal-preview-img {
    max-width: 850px !important;
  }
}

.modal-preview-close-btn {
  opacity: 0.7;
  transition: opacity 0.2s ease;
  line-height: 1;
  cursor: pointer;
}

.modal-preview-close-btn:hover {
  opacity: 1;
}

.modal-preview-close-btn:focus {
  outline: none !important;
  box-shadow: none !important;
}
</style>
